<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <v-tab-item>
        <v-autocomplete
          v-model="attendanceReport"
          label="Report Types"
          :items="reportTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />
        <report-attendance-attendance-report
          v-if="attendanceReport === 'Attendance Report'"
          class="mb-2"
        />
        <report-attendance-monthly-attendance-report
          v-if="attendanceReport === 'Monthly Attendance Report'"
          class="mb-2"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  export default {
    components: {
      ReportAttendanceAttendanceReport: () => import('@/components/hris/reports/attendance/AttendanceReport'),
      ReportAttendanceMonthlyAttendanceReport: () => import('@/components/hris/reports/attendance/MonthlyAttendanceReport'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Attendance Reports' },
        ],
        active: 0,

        attendanceReport: null,
        reportTypes: [
          { name: 'Attendance Report' },
          { name: 'Monthly Attendance Report' },
        ],
      }
    },
  }
</script>
